import { render, staticRenderFns } from "./FlaresPhase.vue?vue&type=template&id=0f7b121c&scoped=true&"
import script from "./FlaresPhase.vue?vue&type=script&lang=js&"
export * from "./FlaresPhase.vue?vue&type=script&lang=js&"
import style0 from "./FlaresPhase.vue?vue&type=style&index=0&id=0f7b121c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b121c",
  null
  
)

export default component.exports